export const STORAGE_KEYS = {
  clientId: 'encore.clientId',
} as const;
